export default "__VITE_ASSET__CXbZZ1o0__"